export default {
  ess_language: {
    language: {
      en_US: 'English (US)',
      es_ES: 'Español',
      ja_JP: '日本語'
    }
  }
}
